import React, { useState } from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import "bootstrap/dist/css/bootstrap.css";
// import $ from "jquery";
// import Popper from "popper.js";
//import "../node_modules/jquery/dist/jquery.min.js";
//import "bootstrap/dist/js/bootstrap.bundle.min";
//jquery and popper are  required by bootstrap 4 for javascript functionality like navbar scrolldown on smaller devices,
//installed seperately. js bootstrap is installed below
import "bootstrap/dist/js/bootstrap.min.js";
import useDeployUpdate from "./hooks/useDeployUpdate";
import { clearUpdateReloadParam, reloadForUpdate } from "./utils/deployUpdate";

clearUpdateReloadParam();

function AppWithVersionGuard() {
  const updateAvailable = useDeployUpdate();
  const [updateDeferred, setUpdateDeferred] = useState(false);

  const handleReload = () => {
    reloadForUpdate();
  };

  return (
    <>
      <App />
      {updateAvailable && !updateDeferred && (
        <div
          role="dialog"
          aria-live="polite"
          aria-label="New version available"
          style={{
            position: "fixed",
            inset: 0,
            backgroundColor: "rgba(0, 0, 0, 0.5)",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            zIndex: 99999,
            padding: "1rem",
          }}
        >
          <div
            style={{
              width: "100%",
              maxWidth: "420px",
              backgroundColor: "#ffffff",
              borderRadius: "12px",
              boxShadow: "0 10px 30px rgba(0, 0, 0, 0.25)",
              padding: "1.25rem",
              textAlign: "center",
            }}
          >
            <h3 style={{ marginTop: 0, marginBottom: "0.75rem", color: "#111827" }}>
              New version available
            </h3>
            <p style={{ marginTop: 0, marginBottom: "1rem", color: "#374151" }}>
              A new update was deployed. Save any changes you are working on,
              then reload to continue with the latest version.
            </p>
            <div
              style={{
                display: "flex",
                justifyContent: "center",
                gap: "0.75rem",
                flexWrap: "wrap",
              }}
            >
              <button
                onClick={() => setUpdateDeferred(true)}
                style={{
                  backgroundColor: "#ffffff",
                  color: "#111827",
                  border: "1px solid #9ca3af",
                  borderRadius: "8px",
                  padding: "0.7rem 1.2rem",
                  fontWeight: 600,
                  cursor: "pointer",
                }}
              >
                Save first
              </button>
              <button
                onClick={handleReload}
                style={{
                  backgroundColor: "#111827",
                  color: "#ffffff",
                  border: "none",
                  borderRadius: "8px",
                  padding: "0.7rem 1.2rem",
                  fontWeight: 600,
                  cursor: "pointer",
                }}
              >
                Reload now
              </button>
            </div>
          </div>
        </div>
      )}
      {updateAvailable && updateDeferred && (
        <div
          role="status"
          aria-live="polite"
          style={{
            position: "fixed",
            right: "1rem",
            bottom: "1rem",
            zIndex: 99999,
            display: "flex",
            alignItems: "center",
            gap: "0.75rem",
            maxWidth: "calc(100% - 2rem)",
            padding: "0.75rem",
            backgroundColor: "#ffffff",
            border: "1px solid #d1d5db",
            borderRadius: "10px",
            boxShadow: "0 8px 24px rgba(0, 0, 0, 0.2)",
            color: "#111827",
          }}
        >
          <span>Save your changes, then reload for the update.</span>
          <button
            onClick={handleReload}
            style={{
              flexShrink: 0,
              backgroundColor: "#111827",
              color: "#ffffff",
              border: "none",
              borderRadius: "8px",
              padding: "0.55rem 0.9rem",
              fontWeight: 600,
              cursor: "pointer",
            }}
          >
            Reload now
          </button>
        </div>
      )}
    </>
  );
}

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <AppWithVersionGuard />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
